export class TenantInvitationRequestSentController {
    static $inject = ['$state', '$stateParams'];
    constructor($state, $stateParams) {
        'ngInject';
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.loading = false;
        this.tenantId = this.$stateParams.id;
        this.tenantName = this.$stateParams.name;
    }
}
TenantInvitationRequestSentController.$inject = ['$state', '$stateParams'];
